define([
	'components/toggleLink/toggleLink',
	'components/megadrop',
	'components/utilities/utilities',
	'components/ajaxForm/ajaxForm',
	'components/autoSubmit/autoSubmit',
	'components/tabUsability/tabUsability',
	'components/loadMore/loadMore',
	'libs/flatpickr',
	'shortcut-buttons-flatpickr',
	'libs/auto-complete',
	'libs/nanoajax',
	'fancybox',
	'google-maps',
	'jquery-locationpicker'
], function (toggleLink, megadrop, utils, ajaxForm, autoSubmit, tabUsability, loadMore, flatpickr, shortcutButtonsPlugin, autoComplete, nanoajax) {
	'use strict';

	/**
	 * App
	 * This is the initialization file for all scripts.
	 * @version 2.0.0
	 * @see {@link http://youmightnotneedjquery.com/}
	 * @exports app
	 */
	var app = {
		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {

			// Initiates the DOMParser polyfill
			utils.domParserPolyfill();

			// Init toggle link
			toggleLink.init();

			// Init ajaxForm
			this._initAjaxForm();

			// Init autosubmit
			autoSubmit.init();

			// Init tabUsability
			tabUsability.init();

			// Init loadmore
			loadMore.init();

			// Init remove news
			this._initRemoveNews();

			// Init table wrap
			this._initRteTableWrap();

			// Init Fancybox
			this._initFancybox();

			// Init antidoteStore
			this._initAntidoteStore();

			// Init Locationpicker
			this._initLocationpicker();

			//Init GoogleMaps
			this._initGoogleMaps();

			// Init MobileNav
			this._initMobileNav();

			// Init Search Clear
			this._initSearchClear();

			// Init Location Clear
			this._initLocationClear();

			// Init Read More
			this._initReadMore();

			// Init Flatpickr
			this._initFlatpickr();

			// Init Autocomplete
			this._initAutoComplete();

			// Init Misc
			this._initMisc();
		},


		/**
		 * Function that initiates the ajax-form functionality.
		 * @private
		 */
		_initAjaxForm: function () {
			var els = document.querySelectorAll('[data-type="ajaxForm"]');

			if (els.length > 0) {
				require(['components/ajaxForm/ajaxForm'], function (AjaxForm) {
					for (var i = 0; i < els.length; i++) {
						var el = els[i],
							ajaxForm = new AjaxForm();

						if (el.getAttribute('data-ajaxform-initiated') === null) {
							ajaxForm.init(el);
							el.setAttribute('data-ajaxform-initiated', true);
						}
					}
				});
			}
		},


		/**
		 * Initiates remove news.
		 * @private
		 */
		_initRemoveNews: function () {
			var el = document.querySelector('[data-type="news-highlight"]');

			if (el !== null) {
				utils.addEventListener(el, 'click', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

					var target = document.getElementById(el.getAttribute('aria-controls'));

					if (target !== null) {
						utils.addClass(target, 'is-animated');

						setTimeout(function () {
							utils.remove(target);
						}, 500);
					}
				});
			}
		},


		/**
		 * Function that wraps all tables in rte with a div to enable the scroll-feature in mobile.
		 * @private
		 */
		_initRteTableWrap: function () {
			utils.forEachElement('.rte table', function (el) {
				var wrapper = document.createElement('div');
				utils.addClass(wrapper, 'table-scrollable');
				utils.wrap(el, wrapper);
			});
		},


		/**
		 * Function that initiates fancybox.
		 * @private
		 */
		_initFancybox: function () {
			var that = this;
			var fancybox = document.querySelector('[data-type="fancybox"]');

			if (fancybox !== null) {
				require(['jquery'], function ($) {
					require('fancybox')($);
					$('[data-type="fancybox"]').fancybox({
						maxWidth: 800,
						maxHeight: 800,
						width: '70%',
						height: '70%',
						type: 'iframe',
						afterShow: function () {
							// Init antidoteAddStore
							that._initAntidoteAddStore($);
						}
					});
				});
			}
		},

		/**
		 * Function that initiates antidote store.
		 * @private
		 */
		_initAntidoteStore: function () {
			var antidoteStore = document.querySelector('[data-type="antidoteStore"]');

			if (antidoteStore !== null) {
				require(['components/antidoteStore/antidoteStore'], function (antidoteStore) {
					antidoteStore.init();
				});
			}
		},

		/**
		 * Function that initiates antidote store.
		 * @private
		 */
		_initAntidoteAddStore: function ($) {
			var frame = document.getElementsByClassName('fancybox-iframe')[0].contentDocument;

			var antidoteAddStore = frame.querySelector('[data-type="antidoteAddStore"]');
			if (antidoteAddStore !== null) {
				require(['components/antidoteStore/antidoteAddStore'], function (antidoteAddStore) {
					antidoteAddStore.init(frame, $);
				});
			}
		},


		/**
		 * Function that initiates locationpicker.
		 * @private
		 */
		_initLocationpicker: function () {

			var locationpicker = document.querySelectorAll('[data-type="jquery-locationpicker"]');

			if (locationpicker != null) {
				require(['jquery', 'jquery-locationpicker'], function ($) {
					utils.forEach(locationpicker, function (location) {
						var latitude = parseFloat(location.getAttribute('data-latitude')),
							longitude = parseFloat(location.getAttribute('data-longitude')),
							radius = parseInt(location.getAttribute('data-marker-radius')),
							zoom = parseInt(location.getAttribute('data-zoom'));

						$(locationpicker).locationpicker({
							location: {
								latitude: latitude,
								longitude: longitude
							},
							zoom: zoom,
							radius: radius,
							enableAutocomplete: true,
							inputBinding: {
								latitudeInput: $('#latitud'),
								longitudeInput: $('#longitud'),
								locationNameInput: $('#address')
							}
						});
					});
				});

			}

		},

		_initGoogleMaps: function () {
			var mapElement = document.getElementById('map');
			var zoomInputField = document.getElementById('zoom');

			if (mapElement != null && zoomInputField != null) {
				require(['jquery', 'jquery-locationpicker'], function ($) {
					var mapContext = $(mapElement).locationpicker('map');
					var map = mapContext.map;
					map.addListener('zoom_changed', function () {
						zoomInputField.value = map.getZoom();
					});
				});
			}

			/* Alt code from Softronic GIC Git repo (replace rows 244-252) */
			/*
			if (mapElement && zoomInputField) {

				var zoomLevel = parseInt(zoomInputField.value);
				var mapContext = $(mapElement).locationpicker('map');
				var map = mapContext.map;

				map.addListener('zoom_changed', function () {
					zoomInputField.value = map.getZoom();
				});
			}
			*/

		},

		/**
		 * Function that initiates mobile nav.
		 * @private
		 */
		_initMobileNav: function () {
			/*document.querySelector('#mobile-nav').addEventListener('change', function (){
				location.href = this.options[this.selectedIndex].value;
			});
			$('#mobile-nav-but1').click(function (){
				var url = window.location.href;
				var newUrl = '';
				for (var i = 0; i < url.length; i++){
					if (url[i] == '/' && url[ i + 1] != '/'){ break; }
					else {newUrl += url[i];}
				}
				var buttonVal = $('#mobile-nav-but1').val();
				buttonVal = buttonVal.substring(1);
				newUrl += buttonVal;
				window.location.href = newUrl;
			});
			$('#mobile-nav-but2').click(function (){
				var url = window.location.href;
				var newUrl = '';
				for (var i = 0; i < url.length; i++){
					if (url[i] == '/' && url[i + 1] != '/'){ break;}
					else {newUrl += url[i];}
				}
				var buttonVal = $('#mobile-nav-but2').val();
				buttonVal = buttonVal.substring(1);
				newUrl += buttonVal;
				window.location.href = newUrl;
			});
			$('#mobile-nav-but3').click(function (){
				var url = window.location.href;
				var newUrl = '';
				for (var i = 0; i < url.length; i++){
					if (url[i] == '/' && url[i + 1] != '/'){ break;}
					else {newUrl += url[i];}
				}
				var buttonVal = $('#mobile-nav-but3').val();
				buttonVal = buttonVal.substring(1);
				newUrl += buttonVal;
				window.location.href = newUrl;
			});
			$('#mobile-nav-but4').click(function (){
				var url = window.location.href;
				var newUrl = '';
				for (var i = 0; i < url.length; i++){
					if (url[i] == '/' && url[i + 1] != '/'){ break;}
					else {newUrl += url[i];}
				}
				var buttonVal = $('#mobile-nav-but4').val();
				buttonVal = buttonVal.substring(1);
				newUrl += buttonVal;
				window.location.href = newUrl;
			});*/
		},


		/**
		 * Function that initiates clearing search
		 * @private
		 */
		_initSearchClear: function () {
			require(['jquery'], function ($) {
				$('#clearSearch, #clearSearchMobile').click(function () {
					var url = window.location.href;
					var query = url.search('query');
					if (query != -1) {
						var endQuery = '';
						for (var i = query; i < url.length; i++) {
							if (url[i] == '&') {
								endQuery = i;
								break;
							}
						}
						if (endQuery == '') {
							endQuery = url.length;
						}
						var newUrl = '';
						for (var j = 0; j < url.length; j++) {
							if (j > endQuery || j < query) {
								newUrl += url[j];
							}
						}
						window.location.href = newUrl;
					}
					else {
						window.location.href = url;
					}

				});
			});
		},

		/**
		 * Function that initiates clearing location
		 * @private
		 */
		_initLocationClear: function () {
			require(['jquery'], function ($) {
				$('#clearLocation').click(function () {
					var url = window.location.href;
					var query = url.search('utgangspunktId');
					if (query != -1) {
						var endQuery = '';
						for (var i = query; i < url.length; i++) {
							if (url[i] == '&') {
								endQuery = i;
								break;
							}
						}
						if (endQuery == '') {
							endQuery = url.length;
						}
						var newUrl = '';
						for (var j = 0; j < url.length; j++) {
							if (j > endQuery || j < query) {
								newUrl += url[j];
							}
						}
						window.location.href = newUrl;
					}
					else {
						window.location.href = url;
					}

				});
			});
		},

		/**
		 * Function that initiates read more
		 * @private
		 */
		_initReadMore: function () {
			require(['jquery'], function ($) {
				$('.show-more').click(function () {
					$(this).prev('.is-hidden').removeClass('is-hidden');
					$(this).hide();
				});
			});
		},



		/**
		 * Initiates Datepicker functionality with Flatpickr
		 * @private
		 */
		_initFlatpickr: function () {
			var datepickers = document.querySelectorAll('[data-type="flatpickr"]');

			utils.forEach(datepickers, function (el) {
				var defaultDate = el.getAttribute('data-default');

				flatpickr(el, {
					defaultDate: defaultDate ? defaultDate : 'today',
					locale: {
						weekdays: {
							shorthand: ['Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör', 'Sön']
						},
						months: {
							longhand: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December']
						}
					},
					plugins: [
						shortcutButtonsPlugin({
							button: [
								{
									label: 'Dagens datum'
								}
							],
							onClick: function (index, fp) {
								fp.setDate(new Date());
							}
						})
					]
				});
			});
		},


		_initAutoComplete: function () {
			var inputSelector = 'input.autocomplete',
				inputs = document.querySelectorAll(inputSelector);

			utils.forEach(inputs, function (input) {
				var queryName = input.getAttribute('name') || 'q',
					id = input.getAttribute('id');

				new autoComplete({
					selector: '#' + id,
					source: function (term, response) {
						var url = mainConfig.autocompleteUrl.indexOf('?') !== -1 ? mainConfig.autocompleteUrl + '&' + queryName + '=' + term : mainConfig.autocompleteUrl + '?' + queryName + '=' + term;
						nanoajax.ajax({
							method: 'GET',
							headers: {
								'X-Requested-With': 'XMLHttpRequest'
							},
							url: url
						},
							function (code, responseText) {
								var data = false,
									suggestions = [];

								if (code === 200) {
									try {
										data = JSON.parse(responseText);
									} catch (e) { }

									if (data) {
										for (var i = 0; i < data.suggestions.length; i++) {
											suggestions.push(data.suggestions[i].label);
										}
									}
								}
								response(suggestions);
							});
					}
				});
			});
		},
		/**
		 * Function that initiates misc scripts
		 * @private
		 */
		_initMisc: function () {

			require(['jquery'], function ($) {
				$(document).ready(function () {
					setFontSize(localStorage.getItem('bigFont'));
				});

				// Toggles between big and normal text size, for accessibility
				function setFontSize ($param) {
					if (typeof (localStorage) != 'undefined') {
						// console.log("Param: " + $param);
						if ($param === true || $param === 'true') {
							localStorage.setItem('bigFont', true);
							$('#biggerFontClick').attr('aria-pressed', 'true');
							$('#mainBody').addClass('bigger-text');
							// console.log("bör vara stor");
						}
						else {
							localStorage.setItem('bigFont', false);
							$('#biggerFontClick').attr('aria-pressed', 'false');
							$('#mainBody').removeClass('bigger-text');
							// console.log("bör vara liten");
						}
					}
				}

				$('#biggerFontClick').click(function () {
					if (typeof (localStorage) != 'undefined') {
						var isBig = localStorage.getItem('bigFont');
						if (isBig === 'false' || isBig === false) {
							return setFontSize(true);
						}
						else {
							return setFontSize(false);
						}
					}
				});
			});
		}
	};


	return app;
});



//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 1
// module chunks = 0